import {Asset} from "@components/asset";
import {UserAvatar} from "@components/UserAvatar";
import {UserFullname} from "@components/UserFullname";
import {format} from "@constants";
import {Task} from "@core/model";
import {Divider, Paper, Stack, Typography} from "@mui/material";
import {translate} from "@util";
import dayjs from "dayjs";

const TaskInfo = ({task}: {task: Task}) => {
  return (
    <Paper
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}>
      <Stack gap={1} direction={"row"} alignItems={"center"}>
        <UserAvatar id={task?.assigneeId} width={32} />
        <Stack>
          <UserFullname userId={task.assigneeId} />
          <Typography variant="caption" lineHeight={1} color="text.secondary">
            {translate("entity.task.assignee")}
          </Typography>
        </Stack>
      </Stack>
      <Asset id={task?.assetId} size="medium" subtitleVariant="caption" />
      <Divider />
      <Typography variant="body2">
        {`${translate("common.label.createdAt")} ${dayjs(task?.createdAt ?? 0).format(format.datetime.short)}`}
      </Typography>
    </Paper>
  );
};

export {TaskInfo};
